(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fairfield-mausefang"] && !Shopify.designMode) return;
  try {
    
  class FairfieldTrapFinder extends HTMLElement {
    connectedCallback() {
      this.questions = [
        {
          title: 'Wie oft kannst du die Falle kontrollieren?',
          text: 'Eine gefangene Maus darf nicht unnötig lange in einer Lebendfalle bleiben.',
          answers: [
            { label: 'Mehrmals täglich', detail: 'Eine häufige Kontrolle ist zuverlässig möglich.', live: 3, snap: 0 },
            { label: 'Einmal täglich', detail: 'Die Kontrolle ist möglich, aber zeitlich begrenzt.', live: 1, snap: 1 },
            { label: 'Nicht zuverlässig', detail: 'Ich bin häufig länger außer Haus.', live: 0, snap: 3 }
          ]
        },
        {
          title: 'Möchtest du die Maus lebend fangen?',
          text: 'Bei einer Lebendfalle musst du das Tier zeitnah und verantwortungsvoll freilassen.',
          answers: [
            { label: 'Ja, unbedingt', detail: 'Das ist mir bei der Auswahl besonders wichtig.', live: 4, snap: 0 },
            { label: 'Ich bin noch unsicher', detail: 'Für mich zählen vor allem Wirksamkeit und Aufwand.', live: 1, snap: 1 },
            { label: 'Nein', detail: 'Eine schnelle Bekämpfung steht für mich im Vordergrund.', live: 0, snap: 4 }
          ]
        },
        {
          title: 'Sind Kinder oder Haustiere in der Nähe?',
          text: 'Jede Falle muss so stehen, dass sie nicht unbeabsichtigt berührt werden kann.',
          answers: [
            { label: 'Nein', detail: 'Der Aufstellort ist nicht frei zugänglich.', live: 1, snap: 1 },
            { label: 'Ja, aber geschützt', detail: 'Ich kann die Falle sicher und unzugänglich platzieren.', live: 1, snap: 1 },
            { label: 'Ja, ohne geschützten Ort', detail: 'Eine sichere Aufstellung ist derzeit nicht möglich.', live: 0, snap: 0, unsafe: true }
          ]
        },
        {
          title: 'Wie stark ist die Aktivität?',
          text: 'Mehrere Spuren oder wiederholte Sichtungen können auf einen größeren Befall hinweisen.',
          answers: [
            { label: 'Einzelne Spuren', detail: 'Ich habe nur wenige Hinweise entdeckt.', live: 1, snap: 1 },
            { label: 'Wiederholte Aktivität', detail: 'Ich sehe regelmäßig neue Spuren.', live: 0, snap: 2 },
            { label: 'Starker Befall', detail: 'Mehrere Räume oder viele Spuren sind betroffen.', live: 0, snap: 2 }
          ]
        }
      ];
      this.answers = [];
      this.step = 0;
      this.app = this.querySelector('[data-finder-app]');
      this.addEventListener('click', (event) => this.handleClick(event));
      this.render();
    }

    handleClick(event) {
      const button = event.target.closest('button');
      if (!button) return;
      if (button.dataset.answer !== undefined) {
        this.answers[this.step] = Number(button.dataset.answer);
        this.render();
      } else if (button.dataset.action === 'next' && this.answers[this.step] !== undefined) {
        this.step += 1;
        this.render();
      } else if (button.dataset.action === 'back' && this.step > 0) {
        this.step -= 1;
        this.render();
      } else if (button.dataset.action === 'restart') {
        this.answers = [];
        this.step = 0;
        this.render();
      }
    }

    render() {
      if (this.step >= this.questions.length) {
        this.renderResult();
        return;
      }
      const question = this.questions[this.step];
      const selected = this.answers[this.step];
      const options = question.answers.map((answer, index) => `
        <button class="ff-trap-finder__option${selected === index ? ' is-selected' : ''}" type="button" data-answer="${index}" aria-pressed="${selected === index}">
          <span class="ff-trap-finder__radio" aria-hidden="true"></span>
          <span><strong>${answer.label}</strong><small>${answer.detail}</small></span>
        </button>
      `).join('');
      this.app.innerHTML = `
        <div class="ff-trap-finder__progress">
          <span>Frage ${this.step + 1} von ${this.questions.length}</span>
          <div class="ff-trap-finder__progress-bar"><i style="width:${((this.step + 1) / this.questions.length) * 100}%"></i></div>
        </div>
        <div class="ff-trap-finder__question">
          <h3>${question.title}</h3><p>${question.text}</p>
          <div class="ff-trap-finder__options">${options}</div>
        </div>
        <div class="ff-trap-finder__controls">
          <button type="button" data-action="back" ${this.step === 0 ? 'disabled' : ''}>Zurück</button>
          <button type="button" data-action="next" ${selected === undefined ? 'disabled' : ''}>${this.step === this.questions.length - 1 ? 'Ergebnis anzeigen' : 'Weiter'} <span aria-hidden="true">→</span></button>
        </div>
      `;
    }

    renderResult() {
      let liveScore = 0;
      let snapScore = 0;
      let unsafe = false;
      this.answers.forEach((answerIndex, questionIndex) => {
        const answer = this.questions[questionIndex].answers[answerIndex];
        liveScore += answer.live;
        snapScore += answer.snap;
        unsafe = unsafe || Boolean(answer.unsafe);
      });
      const type = unsafe ? 'safety' : Math.abs(liveScore - snapScore) < 2 ? 'open' : liveScore > snapScore ? 'live' : 'snap';
      const results = {
        live: { kicker: 'Deine Tendenz', title: 'Die Lebendfalle passt eher zu deinen Angaben.', text: 'Du kannst die Falle häufig kontrollieren und möchtest die Maus lebend fangen. Achte auf eine zeitnahe, verantwortungsvolle Freilassung.', reasons: ['Regelmäßige Kontrolle ist möglich', 'Lebendfang ist dir wichtig', 'Der Aufstellort kann sicher gewählt werden'], href: '/collections/lebend-mausefalle', cta: 'Lebendfallen ansehen' },
        snap: { kicker: 'Deine Tendenz', title: 'Die Schlagfalle passt eher zu deinen Angaben.', text: 'Eine schnelle und zuverlässige Bekämpfung steht für dich stärker im Vordergrund. Stelle die Falle geschützt und exakt am Laufweg auf.', reasons: ['Begrenzte Kontrollmöglichkeiten', 'Schnelle Bekämpfung hat Priorität', 'Wiederholte Aktivität wurde angegeben'], href: '/collections/schlagfallen', cta: 'Schlagfallen ansehen' },
        open: { kicker: 'Noch nicht eindeutig', title: 'Beide Fallentypen kommen für dich infrage.', text: 'Deine Antworten ergeben keine klare Tendenz. Vergleiche Kontrollaufwand, Fangmethode und die sichere Aufstellung.', reasons: ['Beide Varianten können wirksam sein', 'Deine Prioritäten sind ausgeglichen', 'Die korrekte Anwendung entscheidet'], href: '/pages/faq', cta: 'Häufige Fragen vergleichen' },
        safety: { kicker: 'Zuerst sicher aufstellen', title: 'Der aktuelle Aufstellort ist für keine Falle geeignet.', text: 'Bevor du dich entscheidest, benötigst du einen Platz, der für Kinder und Haustiere zuverlässig unzugänglich ist.', reasons: ['Unbeabsichtigte Berührung muss ausgeschlossen sein', 'Ein geschützter Aufstellort hat Vorrang', 'Wir helfen gern bei der Einordnung'], href: '/pages/faq', cta: 'Sicherheitshinweise ansehen' }
      };
      const result = results[type];
      this.app.innerHTML = `
        <section class="ff-trap-finder__result ff-trap-finder__result--${type}">
          <div class="ff-trap-finder__result-copy">
            <p class="ff-mausefang__eyebrow">${result.kicker}</p><h3>${result.title}</h3><p>${result.text}</p>
            <ul>${result.reasons.map((reason) => `<li>${reason}</li>`).join('')}</ul>
          </div>
          <div class="ff-trap-finder__result-actions">
            <a href="${result.href}">${result.cta} <span aria-hidden="true">→</span></a>
            <button type="button" data-action="restart">Antworten ändern</button>
          </div>
        </section>
      `;
    }
  }

  if (!customElements.get('ff-trap-finder')) customElements.define('ff-trap-finder', FairfieldTrapFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
